import { groupBy } from 'lodash';
import pluralize from 'pluralize';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import EstateAccountListService from '/@/modules/estateaccount/services/EstateAccountListService';
import { PredefinedEstateRole } from '/@/modules/role/enums/PredefinedEstateRole';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';

export class EstateAccountSelectConfig extends FormSelectConfig {
  /**
   * @var {boolean}
   */
  includeAuthUser = false;

  constructor(config = {}) {
    super({
      placeholder: Lang.t('estateaccount.select-user'),
      trackBy: 'id',
      groupValues: 'estateAccounts',
      groupLabel: 'group',
      groupSelect: false,
      ...config
    });

    this.includeAuthUser = config.includeAuthUser ?? false;
  }

  async getOptions(params = {}) {
    params = { roleId: PredefinedEstateRole.getEstateRoleIds().join(','), ...params };
    let options = this.options.length
      ? this.options
      : await EstateAccountListService.getRows(params);

    const userId = getters.auth.getUser().id;

    options = options.filter(
      (estateAccount) =>
        this.includeAuthUser ||
        (estateAccount.user.id !== userId && !this.disabledValues.includes(estateAccount.id))
    );

    return this.groupValues
      ? this.getGroupedOptions(options, (item) => item.estateRole.name)
      : this.options;
  }

  getGroupedOptions(options, groupKey) {
    const groupData = [];
    Object.entries(groupBy(options, groupKey)).forEach(([group, estateAccounts]) => {
      groupData.push({
        group: pluralize(group),
        estateAccounts
      });
    });
    return groupData;
  }
}
